class BESSAppProjectCreditAPIService extends BESSAppAPIServiceBase {

    constructor(parent, code) {
        super(parent, 'credit/');
        this.context.credit = code
    }

    apiUpdateScopeOut(scopeOut, scopeOutReason, onSaved = null, onError = null) {
        this._post('scope-out', {
            data: {
                'scope-out': scopeOut,
                'scope-out-reason': scopeOutReason,
            },
            onResult: onSaved,
            onError: onError,
        });
    }


    apiUpdateAnnotation(annotated, annotation, onSaved = null, onError = null) {
        this._post('annotate', {
            data: {
                'annotated': annotated,
                'annotation': annotation,
            },
            onResult: onSaved,
            onError: onError,
        });
    }

    apiCheckDependencies(onSaved, onError = null) {
        this._post('dependency-check', {
            data: {}, onResult: onSaved,
            onError: onError
        });
    }
}